/** @jsx jsx */
import type { StyledProps } from '@compiled/react';
import { styled, css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// WS-2881 - BuiltInActionsSimple does not include the "Add issue" icon, and does not need custom styling like the other styled components in this file
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BuiltInActionsSimple: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div({
	padding: token('space.050'),
	display: 'flex',
});

const disabledButtonWrapperStyle = css({
	position: 'relative',
});

export const DisabledButtonWrapper = (props: any): JSX.Element => (
	<div css={disabledButtonWrapperStyle} {...props} />
);

const disabledButtonOverlayStyle = css({
	position: 'absolute',
	width: '100%',
	height: '100%',
	zIndex: '1000',
	backgroundColor: 'transparent',
	cursor: 'not-allowed',
});

export const DisabledButtonOverlay = (props: any): JSX.Element => (
	<div css={disabledButtonOverlayStyle} {...props} />
);

const dividerStyle = css({
	width: '1px',
	backgroundColor: token('color.border'),
	marginLeft: token('space.050'),
	marginRight: token('space.050'),
	marginTop: token('space.negative.050'),
	marginBottom: token('space.negative.050'),
});

export const Divider = (props: any): JSX.Element => <div css={dividerStyle} {...props} />;
